import { i18n } from '@/locales';
const lc = 'views.hub_adjustment.';
const hubMainReportTableHeader = [
    {
        title: i18n.t(`${lc}item_name`),
        align: 'center',
        sortable: false,
        value: 'name',
        width: 260,
    },
    {
        title: i18n.t(`${lc}order_count`),
        align: 'center',
        sortable: false,
        value: 'orderCount',
        width: 100,
    },
    {
        title: i18n.t(`${lc}supply_value`),
        align: 'center',
        sortable: false,
        value: 'supplyValue',
        width: 150,
    },
    {
        title: i18n.t(`${lc}VAT`),
        align: 'center',
        sortable: false,
        value: 'VAT',
        width: 150,
    },
    {
        title: i18n.t(`${lc}total_amount`),
        align: 'center',
        sortable: false,
        value: 'totalAmount',
        width: 150,
    },
];
export { hubMainReportTableHeader };
